module.exports = __webpack_public_path__ + "images/ms_filter_option.png";